import React from 'react';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';

import AppContent from '../_Shared/Layout/AppContent';

const _ = require('lodash');

class AdvertiserEdit extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            advertiser: props.advertiser
        }
    }
    
    componentDidMount() {
        this.props.onActivate();
    }

    componentDidUpdate(prevProps, prevState) {
        const { advertiser } = this.props;
        if (advertiser !== null && !_.isEqual(prevProps.advertiser, advertiser)) {
            this.setState({ advertiser });
        }
    }

    handleInputChange = (name, value) => {
        this.setState((prevState, state) => {
            return { advertiser: Object.assign({}, prevState.advertiser, { [name]: value, }) }
        });
    }

    updateAdvertiser = e => {
        const { advertiser } = this.state;
        this.props.saveHandler(advertiser);
    }

    render() {
        const { loading } = this.props;
        const { advertiser, } = this.state;
        return (<AppContent>
                    <Grid container spacing={24}>
                        {
                            loading &&
                            <Grid container item spacing={24}><Grid item xs><LinearProgress variant="query" color="secondary" /></Grid></Grid>
                        }
                        <Grid container item spacing={24}>
                            <Grid item lg={6} xl={4}>
                                <TextField autoFocus value={advertiser.name} onChange={e => this.handleInputChange('name', e.target.value)} id="name" name="name" label="Advertiser Name" type="text" fullWidth />
                            </Grid>
                        </Grid>
                        <Grid container item spacing={24} >
                            <Grid item lg={3} xl={2}>
                                <TextField value={advertiser.postClickLookback} onChange={e => this.handleInputChange('postClickLookback', e.target.value)} id="postClickLookback" name="postClickLookback" label="Post Click Lookback" type="number" />
                            </Grid>
                            <Grid item lg={3} xl={2}>
                                <TextField value={advertiser.postViewLookback} onChange={e => this.handleInputChange('postViewLookback', e.target.value)} id="postViewLookback" name="postViewLookback" label="Post View Lookback" type="number" />
                            </Grid>
                        </Grid>
                        <Grid container item spacing={24}>
                            <Grid item lg={6} xl={4}>
                                <TextField value={advertiser.costModifier} onChange={e => this.handleInputChange('costModifier', e.target.value)} id="costModifier" name="costModifier" label="Cost Modifier" type="number" />
                            </Grid>
                        </Grid>

                        <Grid container item spacing={24}>
                            <Grid item lg={6} xl={4}>
                                <Button onClick={this.updateAdvertiser} variant="contained" color="secondary">Save</Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </AppContent >)
    }
}

export default AdvertiserEdit;


// WEBPACK FOOTER //
// ./src/Components/Presentation/Advertisers/AdvertiserEdit.js